<template>
    <BaseField v-bind="$props" v-on="$listeners">
        <input
            type="text"
            :placeholder="placeholder"
            class="value-field"
            :value="value"
            :maxlength="maxLength"
            @input="$emit('update:value', $event.target.value)"
        />
        <template v-slot:afterInput>
            <slot name="afterInput"></slot>
        </template>
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';

export default {
    name: 'StringField',
    components: { BaseField },
    props: {
        ...BaseField.props,
        value: String,
        placeholder: {
            type: String,
            default: 'Text'
        },
        maxLength: {
            type: Number,
            default: 32
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/input.scss";

input[type="text"] {
    width: 100%;
}
</style>
